// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12.0194 0.00219727L15.5094 7.99035L23.4976 11.4804L15.5094 14.9704L12.0194 22.9585L8.52942 14.9704L0.54126 11.4804L8.52942 7.99035L12.0194 0.00219727ZM21.3247 3.32469L19.7559 4.10559L21.3247 4.8865L22.1056 6.45532L22.8865 4.8865L24.4553 4.10559L22.8865 3.32469L22.1056 1.75586L21.3247 3.32469ZM19.3353 14.7559L20.6346 17.3661L23.2449 18.6654L20.6346 19.9647L19.3353 22.575L18.0361 19.9647L15.4258 18.6654L18.0361 17.3661L19.3353 14.7559Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-filter-3-filled')
export default class Filter3FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-3-filled',
    }
  }
}
